/**
 * Demo paket stok ID (product_stock_id) — e-İcraProPlus "Deneme Ürünü".
 * 1946 DEĞİL: 1946 aynı ürünün ÜCRETLİ yıllık paketidir (DEV-3421); onu
 * demo saymak ücretli satışlara 7 günlük lisans açtırıyordu.
 */
export const DEMO_PACKAGE_STOCK_ID = 1947;

/** Demo / ücretsiz paketlerde verilecek lisans süresi (gün). */
export const DEMO_LICENSE_DURATION_DAYS = 7;

export type LicenseDurationUnit = "gun" | "ay";

export interface ResolvedLicenseDuration {
  lisans_suresi: number;
  lisans_sure_birimi: LicenseDurationUnit;
  is_demo: boolean;
}

export function isDemoOrFreePackage(bsk: any): boolean {
  if (bsk.product_stock_id == DEMO_PACKAGE_STOCK_ID) {
    return true;
  }

  const piecePrice = parseFloat(bsk.piece_price);
  if (!isNaN(piecePrice) && piecePrice === 0) {
    return true;
  }

  const price = parseFloat(bsk.price);
  if (!isNaN(price) && price === 0) {
    return true;
  }

  if (bsk.product_stock) {
    const stockPrice = parseFloat(
      bsk.price_type_id == 2 ? bsk.product_stock.price_year : bsk.product_stock.price
    );
    if (!isNaN(stockPrice) && stockPrice === 0) {
      return true;
    }
  }

  if (!bsk.product_stock_id && bsk.product?.price != null) {
    const productPrice = parseFloat(bsk.product.price);
    if (!isNaN(productPrice) && productPrice === 0) {
      return true;
    }
  }

  return false;
}

/**
 * ICW CreateTenant job args için lisans süresini çözer.
 * Demo/ücretsiz: 7 gün. Ücretli: ay cinsinden (aylık piece×1, yıllık piece×12).
 */
export function resolveLicenseDuration(bsk: any): ResolvedLicenseDuration {
  if (isDemoOrFreePackage(bsk)) {
    return {
      lisans_suresi: DEMO_LICENSE_DURATION_DAYS,
      lisans_sure_birimi: "gun",
      is_demo: true,
    };
  }

  return {
    lisans_suresi: bsk.piece * (bsk.price_type_id == 2 ? 12 : 1),
    lisans_sure_birimi: "ay",
    is_demo: false,
  };
}
